<template>
  <div class="header">
    <div class="headerCon clear">
      <router-link to="/" class="fl header_left">
        <img src="../../assets/images/common/logo.png" />
      </router-link>
      <ul class="fr navlist fontsize16 colorfff">
        <template v-for="(item, index) in navlist">
          <el-tooltip
            v-if="item.tips"
            :content="item.tips"
            placement="bottom"
            effect="light"
            :key="index"
          >
            <li :class="[currentNav == item.key ? 'on' : '']">
              <router-link :to="item.url">{{ item.text }}</router-link>
              <div class="unLine">
                <i class="point"></i>
                <span class="line"></span>
              </div>
            </li>
          </el-tooltip>
          <li v-else :class="[currentNav == item.key ? 'on' : '']" :key="index">
            <!-- @click="OnClickNav(item.key)" -->
            <router-link :to="item.url">{{ item.text }}</router-link>
            <div class="unLine">
              <i class="point"></i>
              <span class="line"></span>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>
<script>
import { Tooltip } from "element-ui";
export default {
  data() {
    return {
      navlist: [
        {
          url: "/",
          text: "首页",
          key: "index",
          tips: "",
        },
        {
          url: "/company",
          text: "关于我们",
          key: "company",
          tips: "",
        },
        {
          url: "/product",
          text: "产品中心",
          key: "product",
          tips: "",
        },
        {
          url: "/news",
          text: "新闻动态",
          key: "news",
          tips: "",
        },
        {
          url: "/recruit",
          text: "人才招聘",
          key: "recruit",
          tips: "",
        },
        {
          url: "/contactus",
          text: "联系我们",
          key: "contactus",
          tips: "",
        },
      ],
    };
  },
  computed: {
    currentNav: {
      get() {
        return this.$store.state.currentNav;
      },
      set(val) {
        return this.$store.commit("updateCurrentNav", val);
      },
    },
  },
  components: {
    Tooltip,
  },
  watch: {
    // '$route' (res) {
    // 	console.log('路由变化')
    // 	console.log(res)
    // }
    $route: {
      handler(newName, oldName) {
        let navData = {
          building: "building",
          contactus: "contactus",
          index: "index",
          news: "news",
          company: "company",
          "news-details": "news",
          "product-detail": "product",
          product: "product",
          recruit: "recruit",
        };
        this.currentNav = navData[newName.name];
        // this.$store.commit("updateCurrentNav", newName.name);
        // console.log(newName);
        // console.log(oldName);
      },
      immediate: true,
    },
  },
};
</script>
<style scoped lang="scss">
// $LiWidth: 6.25vw;
$LiWidth: 6.25vw;
.header {
  width: 100%;
  height: 4.17vw;
  background: #fff;
  .headerCon {
    width: 72.92vw;
    height: 3.13vw;
    margin: 0 auto;
    .header_left {
      width: 23.07vw;
      margin-top: 1.04vw;
      img {
        width: 100%;
      }
    }
  }
  .navlist {
    min-width: 37.5vw;
    height: 100%;
    word-spacing: -0.05vw;
    font-size: 0 !important;
    li {
      display: inline-block;
      min-width: $LiWidth - 2.5vw;
      text-align: center;
      line-height: 4.17vw;
      position: relative;
      padding: 0 1.25vw;
      &::before {
        content: "";
        display: block;
        width: 0.05vw;
        height: 0.73vw;
        background: #999;
        position: absolute;
        top: 50%;
        right: 0;
        margin: -0.36vw 0 0 0;
      }
      &:last-child {
        padding: 0 0 0 1.25vw;
        &::before {
          display: none;
        }
      }
      &.on,
      &:hover {
        a {
          color: #87c31e;
        }
        .unLine {
          display: flex;
        }
        &:last-child .unLine {
          margin-left: -$LiWidth/2 + 0.63vw;
        }
      }
      a {
        font-size: 0.83vw;
        color: #333333;
      }
      .unLine {
        display: none;
        width: $LiWidth;
        height: 0.21vw;
        box-sizing: border-box;
        padding: 0 1.46vw;
        position: absolute;
        left: 50%;
        bottom: 1.04vw;
        margin-left: -$LiWidth/2;
        .point {
          display: block;
          width: 0.42vw;
          height: 0.21vw;
          border-radius: 0.26vw;
          background: #87c31e;
        }
        .line {
          flex: 1;
          height: 0.21vw;
          border-radius: 0.26vw;
          background: #87c31e;
          margin-left: 0.21vw;
        }
      }
    }
  }
}

@media (min-width: 1920px) {
  $LiWidth: 130px;
  .header {
    width: 100%;
    height: 80px;
    background: #fff;
    .headerCon {
      width: 1400px;
      height: 60px;
      margin: 0 auto;
      .header_left {
        width: 443px;
        margin-top: 20px;
        img {
          width: 100%;
        }
      }
    }
    .navlist {
      min-width: 720px;
      height: 100%;
      word-spacing: -1px;
      font-size: 0 !important;
      li {
        display: inline-block;
        min-width: $LiWidth - 48px;
        text-align: center;
        line-height: 80px;
        position: relative;
        padding: 0 24px;
        &::before {
          content: "";
          display: block;
          width: 1px;
          height: 14px;
          background: #999;
          position: absolute;
          top: 50%;
          right: 0;
          margin: -7px 0 0 0;
        }
        &:last-child {
          padding: 0 0 0 24px;
          &::before {
            display: none;
          }
        }
        &.on,
        &:hover {
          a {
            color: #87c31e;
          }
          .unLine {
            display: flex;
          }
          &:last-child .unLine {
            margin-left: -$LiWidth/2 + 12px;
          }
        }
        a {
          font-size: 16px;
          color: #333333;
        }
        .unLine {
          display: none;
          width: $LiWidth;
          height: 4px;
          box-sizing: border-box;
          padding: 0 32px;
          position: absolute;
          left: 50%;
          bottom: 20px;
          margin-left: -$LiWidth/2;
          .point {
            display: block;
            width: 8px;
            height: 4px;
            border-radius: 5px;
            background: #87c31e;
          }
          .line {
            flex: 1;
            height: 4px;
            border-radius: 5px;
            background: #87c31e;
            margin-left: 4px;
          }
        }
      }
    }
    // .internationalization {
    //   float: right;
    //   width: 36px;
    //   height: 36px;
    //   line-height: 36px;
    //   text-align: center;
    //   color: #333333;
    //   margin: 22px 0 0 0;
    //   background-color: #ffffff;
    //   border: solid 1px #7fb71f;
    //   border-radius: 50%;
    //   cursor: pointer;
    //   transition: 0.3s ease-in-out;
    //   &:hover {
    //     color: #ffffff;
    //     background: #7fb71f;
    //   }
    // }
  }
}
</style>
